import { SubscriptionInterval } from 'constants/order';
import { PetType } from 'constants/pet-type';

export interface CartBundle {
  bundleId: string;
  quantity: number;
}

export interface BasicCartItemInput {
  variantId: string;
  quantity: number;

  // bundle only
  bundleRefs?: CartBundle[];
  petType?: PetType;
}

export interface SubCartItemInput extends BasicCartItemInput {
  interval?: SubscriptionInterval;
}

export interface RedemptionCartItemInput extends BasicCartItemInput {
  points: number;
  redeemItem: true;
}

export type CartItemInput = BasicCartItemInput | SubCartItemInput | RedemptionCartItemInput;

type WithoutQuantity<T> = T extends any ? Omit<T, 'quantity'> & { quantity?: never } : never;

export type TargetCartItem = WithoutQuantity<CartItemInput>;

export interface UpdateCartItem {
  updateData: CartItemInput;
  target: TargetCartItem;
}

export function isRedemptionCartItemInput(val: any): val is RedemptionCartItemInput {
  return typeof val === 'object' && typeof val['redeemItem'] === 'boolean';
}
